import Vue from "vue";
import Vuex from "vuex";
import UserStore from "@/stores/modules/UserStore";
import UserActivityStore from "@/stores/modules/UserActivityStore";
import ConfigStore from "@/stores/modules/ConfigStore";
import LessonsStore from "@/stores/modules/LessonsStore";
import CourseItemsStore from "@/stores/modules/CourseItemsStore";
import CurrentLessonStore from "@/stores/modules/CurrentLessonStore";
import TeacherRoomStore from "@/stores/modules/TeacherRoomStore";
import LibraryStore from "@/stores/modules/LibraryStore";
import CalendarStore from "@/stores/modules/CalendarStore";
import ChatStore from "@/stores/modules/ChatStore";
import PopupStore from "@/stores/modules/PopupStore";
import ParentStore from "@/stores/modules/ParentStore";
import ThemeStore from "@/stores/modules/ThemeStore";
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    UserStore,
    UserActivityStore,
    ConfigStore,
    LessonsStore,
    CourseItemsStore,
    CurrentLessonStore,
    TeacherRoomStore,
    LibraryStore,
    CalendarStore,
    ChatStore,
    PopupStore,
    ParentStore,
    ThemeStore,
  },
});

export default store;
